import React, { Component } from "react";
import { Grid, Row, Col, Table } from "react-bootstrap";
import Card from "../../components/Card/Card.jsx";
import { NavLink } from "react-router-dom";
import { Query } from "react-apollo";
import gql from "graphql-tag";

import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';
import Button from "../../components/CustomButton/CustomButton.jsx";
import 'react-confirm-alert/src/react-confirm-alert.css'; 
import { confirmAlert } from 'react-confirm-alert'; 


const restLink_account = new HttpLink({ 
  uri: "/api/v1/account/",
  credentials: 'include'
 });
const account_client = new ApolloClient({
  link: restLink_account,
  cache: new InMemoryCache(),
});

const restLink_cloud = new HttpLink({ 
  uri: "/api/v1/cloud/",
  credentials: 'include'
 });
const cloud_client = new ApolloClient({
  link: restLink_cloud,
  cache: new InMemoryCache(),
});

function getUrl($param, $param_1 = null,$param_2 = null) {
  var $url = "/#/"+$param;
  if($param_1 != null) {
    $url += "/"+$param_1;
  }
  if($param_2 != null) {
    $url += "/"+$param_2;
  }
  return $url;
}


const GET_VM = gql`
{
  vms_collections{
    vms{
      id
      uuid
      title
      description
      state
      memory_size_mib
      num_vcpus_per_socket
      num_sockets
      last_update_time_format_br
      creation_time_format_br
      power_state
    }
  }
}
`;

const COUNT_VM = gql`query countVm($search: String!){
  vm_count(search:$search){
    count
  }
}
`;


const DELETE_VM = gql`
   mutation deleteVm($id: Int!){
     deleteVm(id:$id) {
       id
     }
   }
 `;

 const VM_OFF = gql`
  mutation vmOFF($id: Int!){
    vmOFF(id:$id) {
      id
    }
  }
`;

const VM_ON = gql`
    mutation vmON($id: Int!){
      vmON(id:$id) {
        id
      }
    }
  `;


class VmList extends Component {


  state = {
    search: '',
    limit: 20,
    page: 1,
    orderby: "id",
    order: "DESC"
  }

  toggleOrder = (event) => {
    this.setState({
      order: (this.state.order == 'DESC'? 'ASC' : 'DESC')
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    
    this.setState({
      search: event.target.elements.search.value,
      order: event.target.elements.order.value,
      orderby: event.target.elements.orderby.value
    });

  }

  render() {
    
    return (



      <Query
              client={account_client}
              fetchPolicy='no-cache'
                query={gql`{
                  get_authenticated_user{
                    id
                    name
                    uid
                    account {
                      id
                      cnpj
                    }
                  }
                }
                `}
            >
              {({ loading, error, data }) => {
                if (loading) return <div>Olá</div>;
                if (error) return <div>Erro :(</div>;

                  var get_authenticated_user = data.get_authenticated_user;
                  
                return  (

                  <div>

            

                        <div className="content">
                          <Grid fluid>
                            <Row>
                              <Col md={12}>
                                <NavLink
                                    to={'/Vm-Select/'}
                                    className="btn btn-info btn-fill"
                                    activeClassName=""
                                  >
                                  Criar Instância
                                </NavLink>
                                <Card
                                  title={"Instâncias"}
                                  vm="Gerenciar Instâncias"
                                  ctTableFullWidth
                                  ctTableResponsive
                                  content={
                                    
                                    <Table striped hover>
                                      <thead>
                                        <tr>
                                        <th colSpan={9}>
                                              <form 
                                              onSubmit={e => {
                                                this.handleSubmit(e);
                                                e.preventDefault();
                                              }}
                                              >
                                                <Row>
                                                    <Col md={6} lg={3}>
                                                        <input  type="text" name="search" className="form-control" />
                                                    </Col>
                                                    <Col md={2}>
                                                      <Button bsStyle="info" fill type="submit" >
                                                        Buscar
                                                      </Button>
                                                    </Col>
                                                  </Row>
                                                  <Row>
                                                    <Col md={6} lg={1}>
                                                        <select name="orderby" className="form-control">
                                                          <option value="id">ID</option>
                                                          <option value="title">Título</option>
                                                        </select>
                                                    </Col>
                                                    <Col md={6} lg={2}>
                                                        <select name="order" className="form-control">
                                                          <option value="DESC">Decrescente</option>
                                                          <option value="ASC" selected={this.state.order == "ASC"}>Crescente</option>
                                                        </select>
                                                    </Col>
                                                    <Col md={2}>
                                                      <Button bsStyle="info" fill type="submit" >
                                                        Ordenar
                                                      </Button>
                                                    </Col>
                                                  </Row>
                                              </form>
                                          </th>
                                        </tr>
                                      </thead>
                                      <thead>
                                        <tr>
                                          <th>Nome da VM</th>
                                          <th>Descrição</th>
                                          <th>Status Criação</th>
                                          <th>Status VM</th>
                                          <th>RAM</th>
                                          <th>vCPU</th>
                                          <th>Criação</th>
                                          <th>Última atualização</th>
                                          <th></th>
                                          <th></th>
                                          <th></th>
                                          <th></th>
                                          <th></th>
                                        </tr>
                                      </thead>
                                      <tbody>

                                          <Query
                                            client={cloud_client}
                                            query={GET_VM}
                                            fetchPolicy='no-cache'
                                            /*
                                            variables={{
                                              search: this.state.search, 
                                              limit: this.state.limit, 
                                              page: this.state.page, 
                                              order: this.state.order, 
                                              orderby: this.state.orderby
                                            }}
                                            */
                                          >
                                            {({ loading, error, data }) => {
                                              if (loading) return <tr><td>Carregando...</td></tr>;
                                              if (error) return <tr><td>Erro :(</td></tr>;
                                                
                                                if(!data.vms_collections.vms.length) {
                                                  return (<tr><td colSpan={12}><strong>(Você ainda não criou Instâncias)</strong></td></tr>);
                                                } 

                                                return data.vms_collections.vms.map((item) => (
                                                
                                                <tr key={item.id}>
                                                  <td>{item.title}</td>
                                                  <td>{item.description}</td>
                                                  <td><div className={item.state == 'COMPLETE' ? 'color-green' : ''}>{item.state}</div></td>
                                                  <td><div className={item.power_state == 'OFF' ? 'color-red' : (item.power_state == 'PAUSED' ? 'color-orange' : 'color-green')}>{item.power_state}</div></td>
                                                  <td>{item.memory_size_mib / 1024} GB</td>
                                                  <td>{item.num_vcpus_per_socket}</td>
                                                  <td>{item.creation_time_format_br}</td>
                                                  <td>{item.last_update_time_format_br}</td>
                                                  <td>
                                                    {
                                                      item.uuid && 
                                                      <a className="btn btn-success btn-fill" href="">Acessar Instância</a>
                                                    }
                                                  </td>
                                                  <td> 
                                                    {
                                                      item.uuid && 
                                                      <a className="btn btn-info " href={getUrl('VmDisk',item.id)}>Discos</a>
                                                    }
                                                  </td>
                                                  
                                                  <td> 
                                                    {
                                                        item.power_state == 'OFF' ?
                                                            <a className="btn btn-info " href={getUrl('Vm-edit',item.id)}>Editar</a>
                                                            :
                                                            <a className="btn btn-default" title="A instância precisa estar desligada" onClick={() => {alert("A instância precisa estar desligada")}}>Editar</a>
                                                    }
                                                  </td>

                                                  <td>
                                                  {
                                                      item.uuid && 
                                                      (
                                                        item.power_state == 'ON' ?
                                                            <Button bsStyle="warning" onClick={() => {
                                                                  var r = confirmAlert({
                                                                  title: '',
                                                                  message: "Tem certeza que deseja desligar "+item.title,
                                                                  buttons: [
                                                                    {
                                                                      label: 'Sim',
                                                                      onClick: () => {
                                                                        cloud_client.mutate({
                                                                          mutation: VM_OFF,
                                                                          variables: {
                                                                            id:item.id
                                                                          }
                                                                        }).then(
                                                                          result => {
                                                                            window.location.reload();
                                                                        });
                                                                      }
                                                                    },
                                                                    {
                                                                      label: 'Não'
                                                                    }
                                                                  ]
                                                                });
                                                                
                                                              }}>
                                                              Desligar
                                                            </Button>
                                                            :
                                                            <Button bsStyle="success" onClick={() => {
                                                                var r = confirmAlert({
                                                                title: '',
                                                                message: "Tem certeza que deseja ligar "+item.title,
                                                                buttons: [
                                                                  {
                                                                    label: 'Sim',
                                                                    onClick: () => {
                                                                      cloud_client.mutate({
                                                                        mutation: VM_ON,
                                                                        variables: {
                                                                          id:item.id
                                                                        }
                                                                      }).then(
                                                                        result => {
                                                                          window.location.reload();
                                                                      });
                                                                    }
                                                                  },
                                                                  {
                                                                    label: 'Não'
                                                                  }
                                                                ]
                                                              });
                                                              
                                                            }}>
                                                            Ligar
                                                          </Button>
                                                      )
                                                  }
                                                  </td>
                                                  <td>
                                                  <Button bsStyle="danger" onClick={() => {
                                                        var r = confirmAlert({
                                                        title: '',
                                                        message: "Tem certeza que deseja excluir "+item.title,
                                                        buttons: [
                                                          {
                                                            label: 'Sim',
                                                            onClick: () => {
                                                              // Delete item
                                                              cloud_client.mutate({
                                                                mutation: DELETE_VM,
                                                                variables: {
                                                                  id:item.id
                                                                }
                                                              }).then(
                                                                result => {
                                                                  window.location.reload();
                                                              });
                                                            }
                                                          },
                                                          {
                                                            label: 'Não'
                                                          }
                                                        ]
                                                      });
                                                      
                                                    }}>
                                                    Excluir
                                                  </Button>
                                                  </td>
                                                </tr>
                                              ));
                                            }}
                                          </Query>
                                        
                                      </tbody>
                                    </Table>
                                  }
                                />
                              </Col>
                            </Row>
                          </Grid>
                        </div>
                  </div>

                  );
                  }}
                  </Query>
    );
  }
}

export default VmList;
